module.exports = __webpack_public_path__ + "static/media/room-5.df2bb878.jpg";